import './globals/index.scss';
import { initCookieLanguage } from '@/common/ts/cookie-banner/CookieBanner';

if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase())) {
  import('./common/vue/focus-visible-polyfill/focus-visible');
}

initCookieLanguage();
